import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const darkAvatar =
  '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';

export default {
  namespaced: true,
  state() {
    return {
      view: 'Dashboard',
      viewBreadcrumb: 'Dashboard',
      taskView: true,
      settingSelected: 'profile',
      networkError: false,
      encodeDefaultImg: darkAvatar,
      loadPage: false,
      openConsole: false,
      showSidebar: true,
      lastVisitedUrl: null,
      nextRoute: null,
      globalLoading: false,
      loginPlan: null,
      showExpandableCalendar: false,
      contactLinks: [
        {
          category: 'Contact',
          key: 1,
          links: [
            {
              key: 1,
              link: '+27-12-003-6618',
              icon: 'fas fa-phone-alt mirror',
              isTel: true,
              title: '+27-12-003-6618',
            },
            {
              key: 2,
              link: 'https://www.google.com/maps/dir/?api=1&destination=Byls%20Bridge%20Office%20Park%20Ground%20&%20First%20floor,%20Building%2014,%20Block%20B%20Corner%20of%20Olievenhoutbosch%20&,%20Jean%20Ave,%20Doringkloof,%20Centurion,%200157,%20South%20Africa',
              icon: 'fas fa-map-marker-alt',
              title:
                'Byls Bridge Office Park <br />\n' +
                'Ground & First floor, Building 14, Block B<br />\n' +
                'Corner of Olivenhoutbosch & Jean Avenue<br />\n' +
                'Centurion, South Africa, 0157<br />',
            },
          ],
        },
        {
          category: 'Connect',
          key: 2,
          links: [
            {
              key: 3,
              link: 'https://www.youtube.com/channel/UCEhFyyNwsGk-CpD9SjMQemg',
              icon: 'fab fa-youtube',
              title: 'Teamfu',
            },
            {
              key: 4,
              link: 'https://discord.gg/nHEMGDPKN5',
              icon: 'fab fa-discord',
              title: 'Discord',
            },
          ],
        },
      ],
    };
  },
  actions,
  getters,
  mutations,
};
